export default "__VITE_ASSET__DWRa87j0__"